import { render } from "./club-layout.vue?vue&type=template&id=0c3aa67e"
import script from "./club-layout.vue?vue&type=script&lang=js"
export * from "./club-layout.vue?vue&type=script&lang=js"

import "./club-layout.vue?vue&type=style&index=0&id=0c3aa67e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__